import { render, staticRenderFns } from "./VehicleChanges.vue?vue&type=template&id=ae143c1e&"
import script from "./VehicleChanges.vue?vue&type=script&lang=js&"
export * from "./VehicleChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports